import useRouter from 'use-react-router';

export const useRouteParams = <T extends {}>() => {
  const {
    match: { params },
  } = useRouter<T>();
  return params;
};
